import {RelatedContractModel} from './related-contract.model';
import {Utilities} from '@shared/utilities/utilities.model';

export class VehicleModel {
	body_style: string;
	cc_3: string;
	chassis_number: string;
	chassis_number_trailer: string;
	co_2emission: string;
	consumption: string;
	din_hp: any;
	doors: string;
	external_color: string;
	fleet_vehicle_id: string;
	fuel_type: string;
	hp: string;
	internal_color: string;
	kw: string;
	last_known_mileage: string;
	license_plate: string;
	license_plate_trailer: string;
	make: string;
	max_weight: string;
	model: string;
	model_year: string;
	nature: VehicleNature;
	net_weight: string;
	ownership: string;
	registration_country: string;
	registration_country_trailer: string;
	registration_date: string;
	seats: string;
	related_contrancts: RelatedContractModel[];
	net_book_value: number;
	wreck: boolean;

	static getVehicleNature(esbNature: string): VehicleNature | any {
		switch (esbNature.toLowerCase().replace(/ /g, '')) {
			case 'lightcommercialicle': {
				return VehicleNature.VAN;
			}
			case 'v': {
				return VehicleNature.VAN;
			}
			case 'lightcommercialvehicle': {
				return VehicleNature.VAN;
			}
			case 'passengercar': {
				return VehicleNature.MOTORVEHICLE;
			}
			case 'quadriciclo': {
				return VehicleNature.MOTORVEHICLE;
			}
			case 'undefined': {
				return VehicleNature.MOTORVEHICLE;
			}
			case 'c': {
				return VehicleNature.MOTORVEHICLE;
			}
			case 'motorcycle': {
				return VehicleNature.MOTORCYCLE;
			}
			case 'scooter': {
				return VehicleNature.MOTORCYCLE;
			}
			case 'ciclomotore': {
				return VehicleNature.MOTORCYCLE;
			}
			case '1': {
				return VehicleNature.MOTORCYCLE;
			}
			default: {
				return esbNature;
			}
		}
	}

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			Object.assign(this, model, {nature: VehicleModel.getVehicleNature(model.nature)});
		}
	}


}

export enum VehicleNature {
	MOTORVEHICLE = 'MOTOR_VEHICLE',
	MOTORCYCLE = 'MOTOR_CYCLE',
	VAN = 'VAN',
}

export enum VehicleSide {
	A = 'A',
	B = 'B',
}
